<div class="invoice-date-dialog-wrapper">
  <div class="dialog-header">
    <h2 class="dialog-title">Download Invoice</h2>
  </div>

  <div class="invoice-date-dialog-content">
    <p class="message">
      {{ getMessage() }}
    </p>

    <p class="hint">Pre-filled with invoice date. Modify if needed.</p>

    <cac-form-builder [options]="form" />

    <div class="actions">
      <cac-button
        appearance="stroked"
        (onClick)="onCancel($event)"
      >
        Cancel
      </cac-button>

      <cac-button
        appearance="filled"
        (onClick)="onDownload($event)"
      >
        Download
      </cac-button>
    </div>
  </div>
</div>
